export default __webpack_public_path__ + "static/media/niyama_app_icon_modal.01644b8a.svg";